import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=2436171f&scoped=true&"
import script from "./NotificationBell.vue?vue&type=script&lang=js&"
export * from "./NotificationBell.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBell.vue?vue&type=style&index=0&id=2436171f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2436171f",
  null
  
)

export default component.exports